import { createAction, props } from '@ngrx/store';
import { FlamingoTypes } from '@mode/shared/contract-common';
import { FlamingoResponse } from '@mode/shared/contract-common';

export const executePlan = createAction(
  'Flamingo.ExecutePlan',
  props<{
    plan: FlamingoTypes.ModeSelectPlan;
    refId: string;
    queryRunToken: string;
    allowRefresh: boolean;
    vizToken?: string;
  }>()
);

export const executePagePlan = createAction(
  'Flamingo.ExecutePagePlan',
  props<{
    plan: FlamingoTypes.ModeSelectPlan;
    refId: string;
    queryRunToken: string;
    allowRefresh: boolean;
  }>()
);

export const datasetFailed = createAction(
  'Flamingo.DatasetFailed',
  props<{ planId: string; result: FlamingoResponse.DatasetFailureResult }>()
);
export const datasetLoading = createAction(
  'Flamingo.DatasetLoading',
  props<{ planId: string; result: FlamingoResponse.DatasetAllocatedResult }>()
);
export const planFailed = createAction(
  'Flamingo.PlanFailed',
  props<{
    planId: string;
    refId: string;
    response: FlamingoResponse.FlamingoErrorResponse;
  }>()
);
export const planSuccess = createAction(
  'Flamingo.PlanSuccess',
  props<{
    result: FlamingoTypes.ModeSelectResult;
    request: FlamingoTypes.ModeSelectPlan;
    refId: string;
    prevPlanId: string;
  }>()
);
export const sqlResultsSuccess = createAction(
  'Flamingo.SqlResultsSuccess',
  props<{
    result: FlamingoTypes.ModeSelectResult;
    request: FlamingoTypes.ModeRecordsPlan;
    queryToken: string;
  }>()
);
export const pagingSuccess = createAction(
  'Flamingo.PagingSuccess',
  props<{
    result: FlamingoTypes.ModeSelectResult;
    request: FlamingoTypes.ModeRecordsPlan;
    refId: string;
    prevPlanId: string;
  }>()
);
export const executeExportPlan = createAction(
  'Flamingo.executeExportPlan',
  props<{
    queryRunToken: string;
    plan: FlamingoTypes.ModeExportPlan;
    refId: string;
    allowRefresh: boolean;
  }>()
);
export const exportPlanSuccess = createAction(
  'Flamingo.exportPlanSuccess',
  props<{
    request: FlamingoTypes.ModeExportPlan;
    urlOrBlob: string | Blob;
    refId: string;
    prevPlanId: string;
  }>()
);
export const exportPlanFailed = createAction(
  'Flamingo.PlanFailed',
  props<{
    planId: string;
    refId: string;
    response: FlamingoResponse.FlamingoErrorResponse;
  }>()
);
export const refreshSwitchViewSignature = createAction(
  'Flamingo.RefreshSwitchSignature',
  props<{
    executePlanAction: ReturnType<typeof executePlan | typeof executePagePlan | typeof executeExportPlan>;
    reportOwner: string;
    switchViewToken: string;
  }>()
);

export const refreshSwitchViewSignatureSuccess = createAction(
  'Flamingo.RefreshSwitchViewSignatureSuccesss',
  props<{
    executePlanAction: ReturnType<typeof executePlan | typeof executePagePlan | typeof executeExportPlan>;
    signature: string;
    switchViewToken: string;
  }>()
);

export type Union =
  | ReturnType<typeof executePlan>
  | ReturnType<typeof executePagePlan>
  | ReturnType<typeof executeExportPlan>
  | ReturnType<typeof datasetFailed>
  | ReturnType<typeof datasetLoading>
  | ReturnType<typeof planFailed>
  | ReturnType<typeof planSuccess>
  | ReturnType<typeof sqlResultsSuccess>
  | ReturnType<typeof pagingSuccess>
  | ReturnType<typeof refreshSwitchViewSignature>
  | ReturnType<typeof refreshSwitchViewSignatureSuccess>;
